import React from 'react';
import InteractionsMobileHiddenItem from './interactionsMobileHiddenItem';
import type { BiEventDefinition, BiEventFields } from 'types/bi';
import type { HiddenItemData } from '../hiddenItemsData';

interface InteractionsHiddenItemsContainerProps {
  hiddenComps: HiddenItemData[];
  pageId: string;
  sendBi: (event: BiEventDefinition, parameters: BiEventFields) => void;
}

export default class InteractionsHiddenItemsContainer extends React.Component<InteractionsHiddenItemsContainerProps> {
  static displayName = 'InteractionsHiddenItemsContainer';

  render() {
    return (
      <div className="interactions-hidden-items-container">
        <div className="container-comps">
          {this.props.hiddenComps.map((hiddenCompDef) => (
            <InteractionsMobileHiddenItem
              key={hiddenCompDef.compRef.id}
              pageId={this.props.pageId}
              {...hiddenCompDef}
              sendBi={this.props.sendBi}
            />
          ))}
        </div>
      </div>
    );
  }
}
